export const stepperHorizontalData = [
    { id: 1, divClass: 'aboutblock', icon: 'user-male', title: "About", detail: "Add personal details" },
    { id: 2, divClass: 'addressblock', icon: 'address-book', title: "Address", detail: "Add additional info" },
    { id: 3, divClass: 'verifyblock', icon: 'verification-check', title: "Verify", detail: "Complete.. !" },
];